import React, { useId } from "react";
import { useEffect } from "react";
import { useState } from "react";

export default function AppModal({ className, children, activator, isOpen = false }) {
  const modalId = useId();
  const [value, setValue] = useState(isOpen);
  useEffect(() => {
    setValue(isOpen)
  }, [isOpen]);

  return (
    <>
      <label htmlFor={modalId}>{activator}</label>
      <input
        id={modalId}
        type="checkbox"
        className="modal-toggle"
        checked={value}
        onChange={(ev) => setValue(ev.target.checked)}
      />
      <div className="modal bg-black/20">
        <div className={`modal-box relative p-0 rounded-lg ${className}`}>
          <label
            htmlFor={modalId}
            className="z-50 absolute right-2 top-2 rounded-full w-10 h-10 grid place-items-center bg-navy-blue text-white cursor-pointer"
          >
            <i className="iconify text-2xl text-secondary" data-icon="octicon:x-12" />
          </label>
          {children}
        </div>
      </div>
    </>
  );
}
